import React, {useState} from "react";
import PropTypes from "prop-types";
import {QuestionsContainer} from "./AuditQuestions.styles";
import {Divider} from "@mui/material";
import _ from "lodash";
import {GSPSSubmitButton} from "../../Components/Common/GSPSSubmitButton";

export const AuditQuestions = ({
    questions,
    auditorAnswers,
    isReadOnly,
    handleBlur,
    handleChange,
}) => {
    const charLimit = 200;
    const [isShowQuestionsSection, setIsShowQuestionsSection] = useState(true);

    function handleInputChange(index, textValue) {
        if (!isReadOnly) {
            handleChange(index, textValue);
        }
    }

    function handleInputBlur() {
        if (!isReadOnly) {
            handleBlur();
        }
    }

    function renderQuestions() {
        return <div>
            <div className="container-fluid">
                {_.uniq(questions).map((question, index) => (
                    <div key={index} className="row">
                        <div className="col-md-5 col-12">
                            <h2 className="body-md">{question}</h2>
                        </div>
                        <div className="col">
                            <textarea
                                value={auditorAnswers[index] || ""}
                                onChange={(e) =>
                                    handleInputChange(index, e.target.value)
                                }
                                onBlur={handleInputBlur}
                                disabled={isReadOnly}
                                maxLength={charLimit}
                                className="w-100 py-2 px-3"
                            ></textarea>
                        </div>
                    </div>
                ))}
            </div>
        </div>;
    }

    return (
        <QuestionsContainer>
            <div className="d-flex align-items-center mx-2 my-3">
                <h1 className="subtitle-md mb-1">Site Questions</h1>
                <div className="mx-3">
                    <GSPSSubmitButton
                        onClick={() => setIsShowQuestionsSection(!isShowQuestionsSection)}
                        buttonText={isShowQuestionsSection ? "Hide Questions" : "Show Questions"}
                        isLoading={false}
                        isDisabled={false}
                    />
                </div>
            </div>
            {isShowQuestionsSection &&
                <>
                    {questions.length > 0 ? (
                        <>
                            {renderQuestions()}
                        </>
                    ) : "No Questions"}
                </>
            }
            <Divider className="my-3" />
        </QuestionsContainer>

    );
};

AuditQuestions.propTypes = {
    questions: PropTypes.array.isRequired,
    auditorAnswers: PropTypes.array.isRequired,
    isReadOnly: PropTypes.bool.isRequired,
    handleBlur: PropTypes.func,
    handleChange: PropTypes.func,
};
